import { http } from "./http";

// The country waitlist (sign-up from a country that isn't open yet).
// The supported-country list itself is src/lib/supportedCountries.ts.
export const countriesApi = {
  joinWaitlist: (email: string, country: string) => http.post<unknown>("/countries/waitlist", { email, country }),
};
